<template>
  <v-container grid-list-xl fluid>
    <FabricRangeSelector type="Vertical Blind" :value="selectedFabricGroup" v-on:selected-fabric-group="selectedFabricGroup = $event" :v="$v.selectedFabricGroup" :error="$v.selectedFabricGroup.$error"></FabricRangeSelector>

    <FabricSelector :fabricGroupID="selectedFabricGroup" :value="item.fabric" v-on:selected-fabric="selectedFabric = $event"></FabricSelector>

    <ColorSelector :fabricID="selectedFabric" :value="item.color" v-on:selected-color="item.color = $event"></ColorSelector>

    <DimensionSelector v-on:room="setRoom($event)" :valueName="item.name" :valueWidth="item.width" :valueDrop="item.drop" ref="dimensionSelector" @ready="isReady => readyToSubmitDimension = isReady" :type="this.item.type"></DimensionSelector>

    <CustomizationSelector title="Fitting" :value="item.variations.fitting" :options="['Face Fit', 'Recess Fit']" v-on:selected-option="item.variations.fitting = $event" :v="$v.item.variations.fitting" :error="$v.item.variations.fitting.$error"></CustomizationSelector>

    <CustomizationSelector title="Drive Type" :value="item.variations.driveType" :options="['Wand', 'Chain']" v-on:selected-option="item.variations.driveType = $event" :v="$v.item.variations.driveType" :error="$v.item.variations.driveType.$error"></CustomizationSelector>

    <CustomizationSelector title="Wand Type" v-if="item.variations.driveType == 'Wand'" :value="item.variations.wandType" :options="['Left Hand Stack', 'Centre Opening', 'Centre Stack', 'Right Hand Stack']" v-on:selected-option="item.variations.wandType = $event" :v="$v.item.variations.wandType" :error="$v.item.variations.wandType.$error"></CustomizationSelector>

    <CustomizationSelector title="Chain Type" v-if="item.variations.driveType == 'Chain'" :value="item.variations.chainType" :options="['Left Control Left Stack','Right Control Left Stack', 'Right Control Right Stack', 'Left Control Right Stack', 'Left Control Centre Stack', 'Left Control Centre Opening', 'Right Control Centre Opening', 'Right Control Centre Stack']" v-on:selected-option="item.variations.chainType = $event" :v="$v.item.variations.chainType" :error="$v.item.variations.chainType.$error"></CustomizationSelector>

    <CustomizationSelector title="Chain Color" v-if="item.variations.driveType == 'Chain'" :value="item.variations.chainColor" :options="['Black', 'White', 'Grey']" v-on:selected-option="item.variations.chainColor = $event" :v="$v.item.variations.chainColor" :error="$v.item.variations.chainColor.$error"></CustomizationSelector>

    <CustomizationSelector title="Track Color" :value="item.variations.trackColor" :options="['Anodised Silver', 'White', 'Black', 'Birch White', 'Magnolia', 'Beige']" v-on:selected-option="item.variations.trackColor = $event" :v="$v.item.variations.trackColor" :error="$v.item.variations.trackColor.$error"></CustomizationSelector>

    <CustomizationSelector title="Weights" :value="item.variations.weights" :options="['Chained Weights', 'Chainless Weights', 'Sewn in Weights']" v-on:selected-option="item.variations.weights = $event" :v="$v.item.variations.weights" :error="$v.item.variations.weights.$error"></CustomizationSelector>

    <div v-if="incInstall">
      <v-checkbox label="Install?" color="primary" v-model="customInstall"></v-checkbox>
      <v-text-field v-if="customInstall" label="Install Price" v-model="item.installPrice"></v-text-field>
    </div>

    <!-- <v-checkbox label="Motorized?" color="primary" v-model="motorized"></v-checkbox>
    <v-select v-if="motorized" @change="motorActions" v-model="item.motor" :items="[{ text: 'SOMFY - Sonesse 30 Li-ion'},{ text: 'SOMFY - Altus 28 Li-ion'},{ text: 'SOMFY - Altus 40 RTS - wired'},{ text: 'SOMFY - Sonesse 40 30/30 - wired'},{ text: 'ACMEDA - AUTOMATE | Li-ion 1.1'}, { text: 'ACMEDA - AUTOMATE | Li-ion 3.0'}, { text: 'ACMEDA - AUTOMATE | E6 - wired'}]" label="Motor"></v-select>
    <v-text-field v-if="motorized" label="Motor Price" v-model="item.motorPrice" readonly></v-text-field> -->
    <v-textarea name="notes" label="Line Item Notes" v-model="item.notes"></v-textarea>
    <v-btn v-if="!edit" @click="addItem()" color="primary">Add {{ item.type }}</v-btn>
    <v-btn v-else @click="addItem()" color="primary">Update {{ item.type }}</v-btn>
    <b>${{ (item.total).toFixed(2) }}</b>
  </v-container>
</template>

<script>
import ItemService from '@/services/ItemService'

import FabricRangeSelector from '@/components/parts/FabricRangeSelector'
import FabricSelector from '@/components/parts/FabricSelector'
import ColorSelector from '@/components/parts/ColorSelector'
import DimensionSelector from '@/components/parts/DimensionSelector'
import CustomizationSelector from '@/components/parts/CustomizationSelector'
import { required, requiredIf } from 'vuelidate/lib/validators'

const gConfig = require('../../../gConfig.json')

export default {
  props: {
    edittingItem: {
      default: null
    },
    editChange: {
      default: null
    }
  },
  components: {
    FabricRangeSelector,
    FabricSelector,
    ColorSelector,
    DimensionSelector,
    CustomizationSelector
  },
  data () {
    return {
      selectedFabricGroup: null,
      selectedFabric: null,
      customInstall: false,
      motorized: false,
      readyToSubmitDimension: false,
      edit: false,
      item: {
        type: 'Vertical Blind',
        fabric: null,
        color: null,
        name: null,
        width: null,
        drop: null,
        total: 0,
        orderID: null,
        installPrice: 0,
        motor: null,
        motorPrice: 0,
        notes: null,
        variations: {
          fitting: null,
          driveType: null,
          wandType: null,
          chainType: null,
          chainColor: null,
          trackColor: null,
          weights: null
        }
      },
      incInstall: gConfig.install
    }
  },
  validations: {
    item: {
      name: { required },
      drop: { required },
      width: { required },
      variations: {
        fitting: { required },
        driveType: { required },
        wandType: { required: requiredIf(function () { return this.item.variations.driveType === 'Wand' }) },
        chainType: { required: requiredIf(function () { return this.item.variations.driveType === 'Chain' }) },
        chainColor: { required: requiredIf(function () { return this.item.variations.driveType === 'Chain' }) },
        trackColor: { required },
        weights: { required }
      }
    },
    selectedFabricGroup: { required }
  },
  mounted () {
    this.useEdittingItem(this.edittingItem)
  },
  watch: {
    item: {
      handler (item) {
        this.getPrice(item)
      },
      deep: true
    },
    selectedFabric (val) {
      this.item.fabric = val
    },
    motorized (val) {
      if (!val) {
        this.item.motor = null
        this.item.motorPrice = 0
      }
    },
    customInstall (val) {
      if (!val) {
        this.item.installPrice = 0
      }
    },
    edittingItem (item) {
      this.useEdittingItem(item)
    }
  },
  methods: {
    async getPrice (item) {
      const response = await ItemService.getPricing(item)
      if (response.data.price) {
        this.item.total = response.data.price
      }
    },

    setRoom (room) {
      this.item.width = room.width
      this.item.drop = room.drop
      this.item.name = room.name
    },

    addItem () {
      this.$refs.dimensionSelector.touch()
      this.$v.item.$touch()
      this.$v.selectedFabricGroup.$touch()
      if (this.$v.item.$pending || this.$v.item.$error || !this.readyToSubmitDimension || this.$v.selectedFabricGroup.$pending || this.$v.selectedFabricGroup.$error) return

      this.edit = false
      this.$emit('create-item', this.item)
    },

    async motorActions (value) {
      switch (value) {
        case 'SOMFY - Sonesse 30 Li-ion':
          this.item.motorPrice = 295
          break
        case 'SOMFY - Altus 28 Li-ion':
          this.item.motorPrice = 210
          break
        case 'SOMFY - Altus 40 RTS - wired':
          this.item.motorPrice = 265
          break
        case 'SOMFY - Sonesse 40 30/30 - wired':
          this.item.motorPrice = 380
          break
        case 'ACMEDA - AUTOMATE | Li-ion 1.1':
          this.item.motorPrice = 250
          break
        case 'ACMEDA - AUTOMATE | Li-ion 3.0':
          this.item.motorPrice = 350
          break
        case 'ACMEDA - AUTOMATE | E6 - wired':
          this.item.motorPrice = 199
          break
      }
    },

    useEdittingItem (item) {
      if (!this.editChange) {
        if (item) {
          this.edit = true
          this.item = item
          this.selectedFabricGroup = (item.fabric.group._id ? item.fabric.group._id : item.fabric.group)
          this.selectedFabric = (item.fabric._id ? item.fabric._id : item.fabric)
          this.item.color = (item.color._id ? item.color._id : item.color)
          this.motorized = parseInt(item.motorPrice) > 0
          this.customInstall = parseInt(item.installPrice) > 0
        }
      } else {
        this.item = {
          type: 'Vertical Blind',
          fabric: null,
          color: null,
          name: null,
          width: null,
          drop: null,
          total: 0,
          orderID: null,
          installPrice: 0,
          motor: null,
          motorPrice: 0,
          notes: null,
          variations: {
            fitting: null,
            driveType: null,
            wandType: null,
            chainType: null,
            chainColor: null,
            trackColor: null,
            weights: null
          }
        }
        this.item._id = item._id
        this.item.name = item.name
        this.item.width = item.width
        this.item.drop = item.drop
        this.item.orderID = item.orderID
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/VerticalBlind.vue